import styled from '@emotion/styled';

import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header';
import Menu from './menu';

interface LayoutProps {
	children?: React.ReactElement;
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	.-center {
		display: flex;
		flex: 1;
		height: 0;
		.-content {
			flex: 1;
			padding: 10px;
			overflow: hidden;
			overflow-x: scroll;

			& > div {
				min-width: 1000px;
			}
		}
	}
`;

export default function Layout({ children }: LayoutProps): React.ReactElement {
	return (
		<Wrapper>
			<Header />
			<div className="-center">
				<Menu />
				<div className="-content">
					<Outlet />
				</div>
			</div>
		</Wrapper>
	);
}
